import WarehouseServices from "@/services/WarehouseServices.js";

export default {
  getWarehouseList: WarehouseServices.getList,
  getWarehouseDetails: WarehouseServices.getDetails,
  postWarehouse: WarehouseServices.postWarehouse,
  putWarehouse: WarehouseServices.putWarehouse
}